module.exports = __webpack_public_path__ + "static/media/35-brekraftstrategi.0d7aaff3.mp3";